/**
 * 排出事業者の検索ダイアログ(テナントが管理する処分事業者の事業場)
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'
 import * as types from '../../../../mutation-types/driver-types'
 
 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/tenant_disposer_details`
 
 const getDefaultState = () => {
   return {
     pagination: {
       current_page: 1,
       total_count: 0
     },
   }
 }
 const tenant_disposer_detail = {
   namespaced: true,
   state: getDefaultState(),
   getters: {
     hasResult: ( state ) => {
       return (state.pagination.total_count > 0)
     },
   },
   actions: {
     index ({ commit }) {
       return new Promise((resolve) => {
         Vue.$http.get(API_PATH).then(data => {
           let content = data.content
           resolve(content)
         })
       })
     },
   },
   mutations: {
   },
 }
 
 export default tenant_disposer_detail
 